const state = {
  selectedTab: '',
  // Society structure config loaded from API
  hasMultipleBuilding: null,  // null = not loaded, 0 = single, 1 = multiple
  unitType: null,             // 1 = Residential, 2 = Commercial, 3 = Mixed
  unreadChatCount: 0,
};

const mutations = {
  setSelectedTab(state, data) {
    state.selectedTab = data.selectedTab;
  },
  setSocietyConfig(state, data) {
    state.hasMultipleBuilding = data.hasMultipleBuilding;
    state.unitType = data.unitType;
  },
  setUnreadChatCount(state, count) {
    state.unreadChatCount = count;
  },
};

const getters = {
  // true when society has blocks/buildings
  useBlocks: (state) => state.hasMultipleBuilding == 1,
  // label for unit number field
  unitLabel: (state) => {
    if (state.unitType == 2) return 'Shop No';
    if (state.unitType == 1) return 'House No';
    return 'House No / Shop No'; // mixed or unknown
  },
  // label for "Block" column headers (always Block)
  blockLabel: () => 'Block',
  unitType: (state) => state.unitType,
};

const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
